// 老师api

import { baseRequest, fileRequest, saveDownloadFile, baseRequest2 } from './base'
import store from '../vuex'
import Axios from 'axios'
import { notification } from 'ant-design-vue'

/**
 * @desc 查询老师列表
 */
function getTeacherList_all(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaTeacher/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 查询老师列表
 */
function getTeacherList(params) {
  //如果选择了学校，加入学校字段
  params = params ? params : {}

  //清除空白字段
  params = utils.common.checkNull(params)
  // let tempUrl = '/api/pcWeb/teaTeacher/'
  let tempUrl = '/api/pcWeb/teaTeacher/selectTeacherOfCanAddToClass'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 提交待提交老师/提交审核不通过老师
 */
function submitTeacher(teacherId) {
  return baseRequest(
    `/api/pcWeb/teaTeacher/submittingCheckTeaTeacher/${teacherId}`,
    'post'
  )
}

/**
 * @desc 根据老师ID获取老师信息
 */
function getTeacherById(id) {
  return baseRequest(`/api/pcWeb/teaTeacher/${id}`, 'get')
}

/**
 * @desc 新增老师
 */
function addTeacher(params) {
  //清除空白字段
  params = utils.common.checkNull(params)

  return baseRequest(`/api/pcWeb/teaTeacher/create`, 'post', params)
}

/**
 * @desc 删除老师
 */
function deleteTeacher(id) {
  return baseRequest(`/api/pcWeb/teaTeacher/delete/${id}`, 'get')
}

/**
 * @desc 修改老师
 */
function updateTeacher(id, params) {
  //清除空白字段
  params = utils.common.checkNull(params)

  return baseRequest(`/api/pcWeb/teaTeacher/update/${id}`, 'post', params)
}

/**
 * @desc 导入老师
 */
function importTeacher(params) {
  return fileRequest(`/api/pcWeb/teaTeacher/import`, params)
}

/**
 * @desc 校验导入文件表头
 */
function checkHeader(params) {
  return fileRequest(`/api/pcWeb/teaTeacher/checkHeader`, params)
}

/**
 * @desc 校验导入文件信息
 */
function checkFileInfo(params) {
  return fileRequest(`/api/pcWeb/teaTeacher/checkFileInfo`, params)
}

/**
 * @desc 批量删除教室
 */
function batchDelete(params) {
  return baseRequest(`/api/pcWeb/teaTeacher/batchDelete`, 'post', params)
}

// 审核详情
function getCheckOperateLog(teacherId) {
  return baseRequest(
    `/api/pcWeb/teaTeacher/getCheckOperateLog/${teacherId}`,
    'get'
  )
}

// 老师信息录入-- 获取验证码
function loginGetCode(mobile) {
  return baseRequest(
    `/api/pcWeb/teaTeacher/loginGetCode?mobile=${mobile}`,
    'get'
  )
}

/**
 * @desc 老师信息录入-- 获取token
 */
function loginByCode(params) {
  return baseRequest(`api/pcWeb/teaTeacher/loginByCode`, 'post', params)
}

// 老师信息录入-- 获取用户信息
function getMyself() {
  return baseRequest(`api/pcWeb/teaTeacher/getMyself`, 'get')
}

// 老师信息录入-- 下载附件接口
function getFile() {
  baseRequest(`api/pcWeb/teaTeacher/getFile`, 'GET', null, {
    redirectLogin: false,
    responseType: 'arraybuffer',
  })
    .then(saveDownloadFile)
    .catch((e) => {
      notification.error({
        description:
          '可能是审核过程未上传附件，或者审核状态已变更，请刷新页面再次尝试。',
        message: '无法下载附件',
        duration: 10,
      })
      console.log(e)
    })
}

/**
 * @desc 老师信息录入-- 保存/确认提交按钮
 */
function updateSelf(params) {
  return baseRequest(`api/pcWeb/teaTeacher/updateSelf`, 'post', params)
}

/**
 * @desc 灵活老师信息获取
 */
function getFlexibleTeacherInfo(key) {
  return baseRequest(
    `/api/pcWeb/teaTeacher/getFlexibleTeacherInfo/${key}`,
    'get'
  )
}

/**
 * @desc 灵活老师信息审核
 */
function updateFlexibleTeacherStatus(key, params) {
  return baseRequest(
    `/api/pcWeb/teaTeacher/updateFlexibleTeacherStatus/${key}`,
    'get',
    params
  )
}

/**
 * @desc 灵活老师信息历史记录获取
 */
function getCheckOperateLogFlexible(key) {
  return baseRequest(
    `/api/pcWeb/teaTeacher/getCheckOperateLogFlexible/${key}`,
    'get'
  )
}
/**
 * @desc 灵活老师信息--上传附件获取token
 */
function teaTeacherGetOssToken(key) {
  return baseRequest(`/api/pcWeb/teaTeacher/getOssToken/${key}`, 'get')
}

/**
 * @desc 老师考勤上传--选择文件
 */
function chooseFileInfo(params) {
  let id = { termId: params.termId }
  return fileRequest(`/api/pcWeb/report/attendanceImport`, params, id)
}

/**
 * @desc 老师考勤上传--导入信息验证
 */
function importPreview(params) {
  return baseRequest(
    `/api/pcWeb/report/attendanceImportInfoValidation`,
    'get',
    params
  )
}

/**
 * @desc 老师考勤上传--确认导入
 */
function confirmImport(params) {
  return baseRequest(`/api/pcWeb/report/confirmImportAttendance`, 'get', params)
}

/**
 * @desc 老师管理--列表导出
 */
 function exportTeacher(params) {
  return baseRequest(`/api/pcWeb/teaTeacher/exportTeacher`, 'get', params)
}

/**
 * @desc 设置老师--长文本识别
 */
 function verifyTeacher(params) {
  return baseRequest(`/api/pcWeb/teaTeacher/verify`, 'post', params)
}
/**
 * @desc 老师修改回显详情
 */
 function getTeacherDetail(params) {
  return baseRequest(`/api/pcWeb/teaTeacher/getTeacherDetail`, 'get', params)
}
/**
 * @desc 学校老师获取列表
 */
 function getSchoolTeacherList(params) {
  params = utils.common.checkNull(params)
  return baseRequest(`/api/pcWeb/teaTeacher/listTeacher`, 'get', params)
}
// 师资详情
function getTeacher(id) {
  return baseRequest(`/api/teacher/get/${id}`, 'get')
}
// 统计数据
function getTeacherData(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/teacherData/getTeacherData'
  return baseRequest(tempUrl, 'get', params)
}
// 出勤详情
function getTeacherCheckinInfo(id) {
  //清除空白字段
  return baseRequest(`/api/teacher_checkin/getTeacherCheckinInfo/${id}`, 'get')
}

// 任课班级
function getTeacherClasses(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/teacher/getTeacherClasses'
  return baseRequest(tempUrl, 'get', params)
}

// 出勤记录

function getTeacherAttendance(params) {
  params = utils.common.checkNull(params)
  let tempUrl = '/api/teacher/getTeacherAttendance'
  return baseRequest(tempUrl, 'get', params)
}
// 评价记录 
function getTeacherEvaluationRecords(params) {
  params = utils.common.checkNull(params)
  let tempUrl = '/api/teacher/getTeacherEvaluationRecords'
  return baseRequest(tempUrl, 'get', params)
}
// 评价记录 
function getCheckOperateLogBureau(teacherId) {
  return baseRequest(`/api/teacher/getCheckOperateLog/${teacherId}`, 'get')
}
// 获取值班老师
function getDutyTeacher(params) {
  return baseRequest('/api/pcWeb/teaSchoolTeacherOnDuty/listDuty', 'get', params)
}
// 修改值班老师
function updateDutyTeacher(params) {
  return baseRequest2('/api/pcWeb/teaSchoolTeacherOnDuty/updateDuty', 'post', params)
}

// 获取老师授课资质
function getCourseWhitelist(userId) {
  return baseRequest(`/api/teacher/getAptitudeAndCourseWhitelist/${userId}`, 'get')
}

export default {
  getTeacherList,
  getTeacherList_all,
  getTeacherById,
  addTeacher,
  deleteTeacher,
  updateTeacher,
  importTeacher,
  checkHeader,
  checkFileInfo,
  batchDelete,
  submitTeacher,
  getCheckOperateLog,
  getCheckOperateLogBureau,
  loginGetCode,
  loginByCode,
  getMyself,
  getFile,
  updateSelf,
  getFlexibleTeacherInfo,
  updateFlexibleTeacherStatus,
  getCheckOperateLogFlexible,
  teaTeacherGetOssToken,
  chooseFileInfo,
  importPreview,
  confirmImport,
  exportTeacher,
  verifyTeacher,
  getTeacher,
  getTeacherData,
  getTeacherCheckinInfo,
  getTeacherClasses,
  getTeacherAttendance,
  getTeacherEvaluationRecords,
  getTeacherDetail,
  getSchoolTeacherList,
  getDutyTeacher,
  updateDutyTeacher,
  getCourseWhitelist,
}
